<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'CANALES.LBL_INFOCANAL' | translate}}" *ngIf="canal">
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CANALES.LBL_CODIGO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{canal.codigo}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CANALES.LBL_NOMBRE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{canal.nombre}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CANALES.LBL_TIPOCANAL' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{canal.nombreTipoCanal}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CANALES.LBL_CODIGOSHIVAM' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{canal.codigoShivam}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CANALES.LBL_DINERO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{canal.indicadorDinero ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{canal.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CANALES.LBL_RESTRICCIONGESTION' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{canal.indicadorRestriccionGestion ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CANALES.LBL_ACTUALIZACIONDATOSDECONTACTO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{canal.indicadorActDatosTercero ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CANALES.LBL_OTPNUMEROTELEFONO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{canal.indicadorTelefonoOtp ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CANALES.LBL_OTPCORREOELECTRONICO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{canal.indicadorCorreoOtp ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CANALES.LBL_SCORE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{canal.indicadorScore ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CANALES.LBL_FREELANCE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{canal.indicadorFreelance ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid" >
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'CANALES.LBL_EJECUTIVO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{canal.indicadorEjecutivo ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
      </p-panel>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'CANALES.LBL_PRODUCTOS' | translate}}">
        <p-table [columns]="colProducto"
                 [value]="canProductos" selectionMode="single" dataKey="idCanalProducto"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.codigoProducto}}</td>
              <td>{{row.nombreProducto}}</td>
              <td>{{row.tipoProductoBancario}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'CANALES.LBL_ROLES' | translate}}">
        <p-table [columns]="colRoles"
                 [value]="canRoles" selectionMode="single" dataKey="idCanalRol"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.codigoRol}}</td>
              <td>{{row.rol}}</td>
              <td class="text-center">
                <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" disabled="true"></p-checkbox>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length" class="text-center">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>

  <!-- TAB Restricción de Gestión por Estados -->
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'CANALES.LBL_RESTRICCIONGESTIONXESTADOS' | translate}}">
        <app-canales-restricciones-gestion-estados [canal]="canal" [esDetalle]="true"></app-canales-restricciones-gestion-estados>
      </p-panel>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>

